import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { fontWeight, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style, styleVariants } from '@vanilla-extract/css';

export const streamPriceLabelContainerBase = style([
  {
    whiteSpace: 'nowrap',
  },
]);

export const streamPriceLabelContainer = styleVariants({
  primary: [
    streamPriceLabelContainerBase,
    typography.bodyMd,
    {
      color: themeVars.container.foreground.primary,
    },
  ],
  secondary: [
    streamPriceLabelContainerBase,
    typography.labelMd,
    {
      color: themeVars.container.foreground.secondary,
    },
  ],
  unlocked: [
    streamPriceLabelContainerBase,
    typography.labelMd,
    {
      display: 'inline-flex',
      alignItems: 'center',
      gap: space.s4,
      color: themeVars.container.foreground.success,
    },
  ],
});

export const streamPriceLabelUnlockedPrice = style({
  fontWeight: fontWeight.semibold,
});

export const streamPriceLabelHighlighted = style([
  typography.bodyLg,
  { fontWeight: fontWeight.semibold },
]);
